var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DashboardCardScaffold", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex items-center" },
              [
                _c("InboxIcon", {
                  staticClass: "h-8 w-8 fill-current text-primary-500 mr-2",
                }),
                _c("p", { staticClass: "font-semibold text-base" }, [
                  _vm._v("Inbox"),
                ]),
              ],
              1
            ),
            _c("UiButton", {
              attrs: { buttonText: "New Conversation", id: "dashboardInbox" },
              on: { click: _vm.redirectToInbox },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }